import { either } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import { useInputText } from 'utils/text';
import { cx } from '@linaria/core';
import React from 'react';
import { flex } from 'styles/utils';
import { carouselItem, carouselTextItem } from 'components/CarouselThumb/CarouselThumb.styles';

/**
 * Carousel text input thumbnail
 */
export const TextThumb: React.FC<Props> = ({ input, onClick, isSelected, className, disabled, ...rest }) => {
  const text = useInputText(input);
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cx(
        carouselItem,
        isSelected && 'selected',
        flex.init,
        flex.alignItems.center,
        flex.justifyContent.center,
        carouselTextItem,
        className,
      )}
      {...rest}
    >
      <span className={cx('text', carouselItem, isSelected && 'selected', flex.init, flex.alignItems.center, flex.justifyContent.center)}>
        {pipe(
          text,
          either.map((txt) => {
            // eslint-disable-next-line react/no-array-index-key
            return [<>{`${txt.slice(0, 8)}...`}</>];
          }),
          either.getOrElse(() => [<>Invalid or unsupported text data.</>]),
        )}
      </span>
    </button>
  );
};

interface Props {
  input: CF.API.Inputs.TextInput;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isSelected: boolean;
  className?: string;
  disabled?: boolean;
}
